import { initializeFilterable } from './blocks/filterables.js';

const allActivitiesBlockClass = 'Block--allActivities';

const $allActivitiesBlocks = document.querySelectorAll(`.${allActivitiesBlockClass}`);
$allActivitiesBlocks.forEach($allActivitiesBlock => {
  initializeFilterable($allActivitiesBlock, {
    filtersClass: 'Filters--activities',
    resultsContainerClass: 'ActivitiesFeed',
    emptyContainerClass: 'ActivitiesFeed',
    loadingContainerClass: 'ActivitiesFeed__Loading'
  })
});
